import React, { useState, useCallback } from 'react';

const LanguageDropdown = ({ onSelectLanguage, onGameChange, isGameActive }) => {
  const [selectedLanguage, setSelectedLanguage] = useState({ display: 'Language', code: '' });

  const languages = [
    { code: 'german', name: 'German', nativeName: 'Deutsch' },
    { code: 'dutch', name: 'Dutch', nativeName: 'Nederlands' },
    { code: 'spanish', name: 'Spanish', nativeName: 'Español' },
    { code: 'french', name: 'French', nativeName: 'Français' }
  ];

  const handleLanguageSelect = useCallback((language) => {
    setSelectedLanguage({ display: language.nativeName, code: language.code });
    onSelectLanguage(language.code);

    if (isGameActive) {
      onGameChange(language.code);
    }
  }, [onSelectLanguage, onGameChange, isGameActive]);

  return (
    <li className="dropdown">
      <button 
        className="nav-link dropdown-toggle"
        id="navbarLanguageDropdownMenu" 
        data-bs-toggle="dropdown" 
        aria-expanded="false"
      >
        {selectedLanguage.display}
      </button>

      <ul className="dropdown-menu" aria-labelledby="navbarLanguageDropdownMenu">
        {languages.map((lang) => (
          <li key={lang.code}>
            <button 
              className="dropdown-item" 
              onClick={() => handleLanguageSelect(lang)}
            >
              {lang.name}
            </button>
          </li>
        ))}
      </ul>
    </li>
  );
};

export default LanguageDropdown;
